var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createBrowserHistory } from 'history';
import { pathToRegexp, compile } from 'path-to-regexp';
function getParams(path, url) {
    var mutableKeys = [];
    var r = pathToRegexp(path, mutableKeys, { end: false }).exec(url) || [];
    return mutableKeys.reduce(function (acc, key, i) {
        var _a;
        return (__assign((_a = {}, _a[key.name] = r[i + 1], _a), acc));
    }, {});
}
export function expandPath(currentPath, currentUrl, path) {
    var params = getParams(currentPath, currentUrl);
    return compile(path)(params);
}
export default createBrowserHistory();
//# sourceMappingURL=history.js.map